export default "__VITE_ASSET__8abbe410__"